export const TEAM_FETCH_INVALID_PAYLOAD = 'TEAM_FETCH_INVALID_PAYLOAD';
